import React, { useEffect, useState } from "react";
import style from "../addUser/addUser.module.css";
import { useNavigate } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
// import Table from "react-data-table-component";
import Table, { tableCustomStyles } from "../../components/CommonComponents/Table/Table";
import PageHeader from "../../components/pageHeader/pageHeader";
import { _axios } from "../../utils/axios";
import Paginator, { PaginatorForRDT } from "../../components/CommonComponents/Paginator/Paginator";
import { useDebounce } from "../../hooks/common";
import { BASE_URL } from "../../constants/Constants";
import Dropdown from 'react-bootstrap/Dropdown';
import Edit from "../../assets/EditInWhite.svg";
import BoxComponent from "../../components/CommonComponents/BoxComponent/BoxComponent";
import EditButton, { ViewButton } from "../../components/CommonComponents/EditComponent/EditComponent";
import { formatDate } from "../../utils/date";

const AddUser = () => {
  const [totalList, setTotalList] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [adminList, setAdminList] = useState<Array<any>>([]);
  const [isGridView, setIsGridView] = useState(false);
  const search = useDebounce(searchQuery);
  const navigate = useNavigate();
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [selectedActiveFilter, setSelectedActiveFilter] = useState<string[]>([]);
  const [sortColumn, setSortColumn] = useState('name');
  const [sortDirection, setSortDirection] = useState('ASC')

  const getUsers = () => {
    _axios.post(`${BASE_URL}/api/admin/list`,
      {
        page: currentPage,
        limit: entriesPerPage,
        search: search,
        filters: selectedFilters,
        activeFilter: selectedActiveFilter,
        sortColumn: sortColumn,
        sortDirection: sortDirection
      })
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        setTotalList(response.data.data.total_rows)
        setAdminList([...response.data.data.results])

        // handle success
        console.log(response);
      })
      .catch(function (error: any) {
        // handle error
        console.log(error);
      })
  }

  useEffect(() => {
    getUsers()
  }, [currentPage, search, selectedFilters, selectedActiveFilter, sortColumn, sortDirection])

  const updateStatus = (mobile: string, status: number) => {
    _axios.patch(`${BASE_URL}/api/admin/status`,
      {
        'active': status === 1 ? 0 : 1,
        'mobile': mobile
      })
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        SuccessToast('User Updated')
        getUsers()
        // handle success
        console.log(response);
      })
      .catch(function (error: any) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }

  const columns = [
    {
      name: 'Sr. No.',
      // selector: (row: any, rowIndex: number | undefined) =>
      //   (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1,
      selector: (log: any, rowIndex: number | undefined) => {
        const serialNumber = (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1;
        return serialNumber.toString().padStart(3, '0');
      },
      sortable: false,
      grow: 0.5,
    },
    {
      name: 'User Name',
      selector: (row: any) => row.name,
      sortable: true,
      width: "380px",
      grow: 3,
    },
    {
      name: 'User Role',
      selector: (row: any) => row.role,
      sortable: true,
      grow: 2,
    },
    {
      name: 'Status',
      width: "120px",
      selector: (row: any) => row.active,
      sortable: true,
      cell: (row: any) => (
        <button
          // onClick={() => updateStatus(row.mobile, row.active)}
          className={row.active === 1 ? "activeButtonCss" : "inactiveButtonCss"}
        >
          {row.active === 1 ? "Active" : "Inactive"}
        </button>
      )
    },
    {
      name: 'Created By',
      selector: (row: any) => row.created_by,
      cell: (row: any) => <span className="text-center">{row.created_by}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: 'Created On',
      selector: (row: any) => formatDate(new Date(row.created_on)),
      sortable: true,
      width: "170px",
    },
    {
      name: 'Modified By',
      selector: (row: any) => row.modified_by,
      cell: (row: any) => <span className="text-center">{row.modified_by}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: 'Modified On',
      selector: (row: any) => formatDate(new Date(row.modified_on)),
      sortable: true,
      width: "170px",
    },
    {
      name: 'Action',
      grow: 1,
      width: "120px",
      selector: (row: any) => (
        // <img
        //   src={Edit}
        //   alt="Edit"
        //   onClick={() => { navigate("/edit-user", { state: { user: row } }) }}
        //   className="globalEditCss"
        // />
        <div className="flex space-x-2">
          <EditButton
            onClick={() => { navigate("/edit-user", { state: { user: row } }) }}
          />
          <ViewButton
            disabled={true}
            onClick={function (): void {
              throw new Error("Function not implemented.");
            }}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  const dropdownContent = (
    <div className={style.dropdownBox}>
      <ul>
        <Dropdown.Menu show className={style.DropDropMenu}>
          <div className={style.dropContent}>
            <Dropdown.Header className={style.DropTile}>Add User List filter</Dropdown.Header>
            <ul>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedActiveFilter.includes('1')}
                    onChange={() => handleActiveFilter("1")} // Update filter options
                  />{" "} <label >Active Status</label>
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedActiveFilter.includes('0')}
                    onChange={() => handleActiveFilter("0")}
                  />{" "}Inactive Status
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes("Level 1")}
                    onChange={() => handleFilterChange("Level 1")}
                  />{" "}Level 1
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes("Level 2")}
                    onChange={() => handleFilterChange("Level 2")}
                  />{" "}Level 2
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes("Level 3")}
                    onChange={() => handleFilterChange("Level 3")}
                  />{" "}Level 3
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes("System admin")}
                    onChange={() => handleFilterChange("System admin")}
                  />{" "}System admin
                </div>
              </li>
            </ul>
          </div>
        </Dropdown.Menu>
      </ul>
    </div>
  );

  const handleActiveFilter = (filterValue: string) => {
    setSelectedActiveFilter((prevSelected) => {
      if (prevSelected.includes(filterValue)) {
        // If the filter is already selected, remove it
        return prevSelected.filter((item) => item !== filterValue);
      } else {
        // If the filter is not selected, add it
        return [...prevSelected, filterValue];
      }
    });
  };

  const handleFilterChange = (filterValue: string) => {

    const index = selectedFilters.indexOf(filterValue);
    if (index === -1) {
      setSelectedFilters([...selectedFilters, filterValue]);
    } else {
      const updatedFilters = [...selectedFilters];
      updatedFilters.splice(index, 1);
      setSelectedFilters(updatedFilters);
    }
  };



  return (
    <div className="p-8 overflow-auto">
      <PageHeader
        title="System Users"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        showSearchButton={true}
        showAdditionalButton={true}
        buttonTitle="New User"
        onClick={() => { navigate("/new-user") }}
        isGridView={isGridView}
        onGridIconClick={() => setIsGridView(!isGridView)}
        showFilterButton={true}
        dropdownContent={dropdownContent}
      />
      {isGridView ?
        <>
          <BoxComponent>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
              {adminList?.map((row: any) => {
                return (
                  <div className="p-4 rounded-2xl bg-white flex flex-col shadow-lg border border-gray-300">
                    <div className="flex justify-between items-center space-x-4 mb-4">
                      <button
                        className={row.active === 1 ? "activeButtonCss" : "inactiveButtonCss"}
                      >
                        {row.active === 1 ? "Active" : "Inactive"}
                      </button>
                      <div className="flex justify-center space-x-1">
                        {/* <img src={Edit} alt="Edit" onClick={() => { navigate("/edit-user", { state: { user: row } }) }} className="globalEditCss" /> */}
                        <EditButton
                          onClick={() => { navigate("/edit-user", { state: { user: row } }) }}
                        />
                        <ViewButton
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="mb-2 flex">
                      <p className="font-bold text-base w-1/2">User Name</p>
                      <p className="text-base mx-2">:</p>
                      <p className="text-base w-2/3">{row?.name}</p>
                    </div>
                    <div className="mb-2 flex">
                      <p className="font-bold text-base w-1/2">User Role</p>
                      <p className="text-base mx-2">:</p>
                      <p className="text-base w-2/3">{row?.role ?? ''}</p>
                    </div>
                  </div>
                )
              })
              }
            </div>
            <Paginator
              limit={entriesPerPage}
              page={currentPage}
              setPage={setCurrentPage}
              count={totalList || 0}
            />
          </BoxComponent>
        </>
        :
        <BoxComponent>
          <Table
            columns={columns}
            data={adminList}
            pagination
            paginationTotalRows={totalList || 0}
            onChangePage={(p) => { console.log('setCurrentPage', p); setCurrentPage(p) }}
            customStyles={tableCustomStyles}
            paginationComponent={PaginatorForRDT}
          />
        </BoxComponent>}
    </div>
    // </div>
  );
};

export default AddUser;
